import { AppConstants } from "../constants/AppConstants";
import { HTTP_STATUS } from "../http/constants/http.status";
import { getUsers } from "../http/user-management-services";

export const fetchFromCookie = (key: string) => {
  const cookieString = document.cookie;
  const cookies = cookieString.split("; ");

  const cookie = cookies.find((cookie) => cookie.startsWith(`${key}=`));

  if (cookie) {
    return cookie.split("=")[1];
  }

  return null;
};

export const setCookie = (key: string, value: string) => {
  document.cookie = `${key}=${encodeURIComponent(value)}; path=/;`;
};

export const getLoginUserName = () => {
  return getUserName(JSON.parse(localStorage.getItem("user-profile") || "{}"));
};

export const getLoginUserRoles = () => {
  return getUserRoles(JSON.parse(localStorage.getItem("user-profile") || "{}"));
};

export const getLoginUserId = () => {
  return getUserId(JSON.parse(localStorage.getItem("user-profile") || "{}"));
};

export const getLoggedInOrgName = () => {
  return getLoggedOrgName(
    JSON.parse(localStorage.getItem("user-profile") || "{}")
  );
};

export const getUserName = (userProfile: any) => {
  let profile: string = "";
  if (userProfile) {
    const { name = [], firstName, lastName, userName, mail } = userProfile;
    if (name.length) {
      const { text, given, family } = name[0];
      profile = text ? text : given && family ? `${given} ${family}` : "";
    }

    if (!profile) {
      profile =
        firstName && lastName
          ? `${firstName} ${lastName}`
          : userName || mail || "";
    }
  }
  return profile;
};

export const getUserRoles = (userProfile: any) => {
  let userRoles: Array<any> = [];
  if (!userProfile || !Object.keys(userProfile).length) {
    return userRoles;
  }
  const { roles = [] } = userProfile;
  userRoles = [...roles];
  return userRoles;
};

export const getUserId = (userProfile: any) => {
  const { userId } = userProfile;
  return userId;
};

export const getLoggedInOrg = (userProfile?: any) => {
  let loggedInOrg;
  let profile =
    userProfile || JSON.parse(localStorage.getItem("user-profile") || "{}");
  if (!profile) {
    return loggedInOrg;
  }
  const { organization = [] } = profile;
  [loggedInOrg] = organization.filter((e: any) => e.loggedIn);
  return loggedInOrg;
};

export const getLoggedOrgName = (userProfile: any) => {
  let data: string = "";
  if (!userProfile || !Object.keys(userProfile).length) {
    return data;
  }
  const { loggedInOrgName } = userProfile;

  return loggedInOrgName ? loggedInOrgName : "";
};

export const getUserProfiles = async (userIds: Array<string> = []) => {
  let userProfiles: Array<any> = new Array();
  const userFilter = `[{"field":"userId","operation":"in","value":"${userIds.join()}"}]`;
  const userResponse = await getUsers(
    userFilter,
    AppConstants.DEFAULT_PAGE,
    AppConstants.MAXIMUM_PAGE_SIZE
  );
  const { status, data: responseData } = userResponse;
  if (status === HTTP_STATUS.HTTP_OK) {
    const { data: userList = [] } = responseData;
    userProfiles = [...userList];
  }
  return userProfiles;
};

const getConsentRoleList = (invitationPolicy: any, loggedInRole: any) => {
  const { value: invitationRoles } = invitationPolicy;
  const consentRolesList: any = [];

  Object.keys(invitationRoles).forEach((role: any) => {
    if (invitationRoles[role].includes(loggedInRole)) {
      consentRolesList.push(role);
    }
  });
  return consentRolesList;
};
